/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createBookmark.defs'
export { main as default } from './createBookmark.defs'
